var SECTION_SELECTOR = function (target) {
    return "[data-composer-section=\"".concat(target, "\"]");
};
var HIGHLIGHT_CLASS = 'composer-section-highlight';
var HIGHLIGHT_STYLE_ID = 'composer-section-highlight-styles';
/** Two pulses at 1.2s each — long enough to notice after smooth scroll. */
var HIGHLIGHT_DURATION_MS = 2400;
var activeHighlight = null;
function getComposerSection(target) {
    return document.querySelector(SECTION_SELECTOR(target));
}
/**
 * Injects highlight keyframes once. Uses Ant design tokens so the pulse
 * matches the rest of the composer error chrome.
 */
function ensureHighlightStyles() {
    if (document.getElementById(HIGHLIGHT_STYLE_ID))
        return;
    var style = document.createElement('style');
    style.id = HIGHLIGHT_STYLE_ID;
    style.textContent = "\n    @keyframes composer-section-highlight-pulse {\n      0%, 100% {\n        background-color: transparent;\n      }\n      35%, 65% {\n        background-color: var(--ant-color-error-bg);\n      }\n    }\n    [data-composer-section].".concat(HIGHLIGHT_CLASS, " {\n      animation: composer-section-highlight-pulse 1.2s ease-in-out 1;\n    }\n  ");
    document.head.appendChild(style);
}
function clearActiveHighlight() {
    if (!activeHighlight)
        return;
    activeHighlight.el.classList.remove(HIGHLIGHT_CLASS);
    window.clearTimeout(activeHighlight.timer);
    activeHighlight = null;
}
/**
 * Scrolls the composer body to the section anchored with
 * `data-composer-section={target}`
 */
export function scrollToComposerSection(target) {
    var _a;
    (_a = getComposerSection(target)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
    });
}
/**
 * Briefly pulses the section anchored with `data-composer-section={target}`
 * (error-tint inset border + background). Safe to call repeatedly — only one
 * section is highlighted at a time.
 */
export function highlightComposerSection(target, durationMs) {
    if (durationMs === void 0) { durationMs = HIGHLIGHT_DURATION_MS; }
    var el = getComposerSection(target);
    if (!el)
        return;
    ensureHighlightStyles();
    clearActiveHighlight();
    // Restart the animation if the same section is re-targeted.
    el.classList.remove(HIGHLIGHT_CLASS);
    void el.offsetWidth;
    el.classList.add(HIGHLIGHT_CLASS);
    var timer = window.setTimeout(function () {
        el.classList.remove(HIGHLIGHT_CLASS);
        if ((activeHighlight === null || activeHighlight === void 0 ? void 0 : activeHighlight.el) === el)
            activeHighlight = null;
    }, durationMs);
    activeHighlight = { el: el, timer: timer };
}
/** Scrolls to and highlights the section in one call. */
export function scrollToHighlight(target) {
    scrollToComposerSection(target);
    highlightComposerSection(target);
}
